import axios from "axios";
import { LibraryOutlet, LoadedProfileResponseDto } from "../types";

class BlocksService {
    async getLibraryOutlet(outletId: string, clientId: string, bypassCache = false): Promise<LibraryOutlet> {
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/library-outlet/${clientId}/${outletId}`,
            bypassCache ? { params: { bypassCache: "true" } } : {}
        );
        return response.data.data;
    }

    async getPopulatedLibraryOutlet(
        outletId: string,
        clientId: string,
        profileId: string,
        versionId: string | undefined = undefined,
        bypassCache = false
    ): Promise<LoadedProfileResponseDto> {
        const params: Record<string, string> = {};
        if (versionId) params.versionId = versionId;
        if (bypassCache) params.bypassCache = "true";
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/profile/${clientId}/${outletId}/${profileId}/populated`,
            { params }
        );
        return response.data.data;
    }
}

export const blocksService = new BlocksService();